export const getHslArgs = (data) => {
    const index = data.selectIndex;

    return {
        hslPickColors: [data.hsl.hsl_hue[index], data.hsl.hsl_saturation[index], data.hsl.hsl_light[index]],
        pickColors: data.hsl.pickColors ? data.hsl.pickColors?.split(',').map((v) => +v / 255) : '',
    };
};
